import { render, staticRenderFns } from "./ViewFooterHome.vue?vue&type=template&id=763a7231&scoped=true&"
import script from "./ViewFooterHome.vue?vue&type=script&lang=js&"
export * from "./ViewFooterHome.vue?vue&type=script&lang=js&"
import style0 from "./ViewFooterHome.vue?vue&type=style&index=0&id=763a7231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763a7231",
  null
  
)

export default component.exports